import Home from '@/pages/Home';
import { StreamingPage } from '@/pages/StreamingPage';
import Interview from '@/pages/Interview';
import { SttTestPage } from '@/pages/SttTestPage';
import InterviewEnded from '@/pages/InterviewEnded';
import Report from '@/pages/Report';
import MobileWebcamSetupPage from '@/pages/MobileWebcamSetupPage';
import MobileInterviewEnded from '@/pages/MobileInterviewEnded';

// 🔧 ROUTER CONFIGURATION - Add your routes here
export const routesConfig = [
  {
    path: '/stt-test',
    component: SttTestPage,
    title: 'STT Test'
  },
  // {
  //   path: '/',
  //   component: Home,
  //   title: 'Home'
  // },
  {
    path: '/streaming',
    component: StreamingPage,
    title: 'Streaming'
  },
  {
    path: '/interview/:id',
    component: Interview,
    title: 'Interview'
  },
  {
    path: '/interview-ended/:id',
    component: InterviewEnded,
    title: 'Interview Ended'
  },
  {
    path: '/report/:id',
    component: Report,
    title: 'Report'
  },
  {
    path: '/mobile-webcam',
    component: MobileWebcamSetupPage,
    title: 'Mobile Webcam Setup'
  },
  {
    path: '/mobile-webcam/interview-ended',
    component: MobileInterviewEnded,
    title: 'Mobile Interview Ended'
  },
  {
    path: '/',
    component: Interview,
    title: 'Interview'
  },
] as const;

// Type definitions for type safety
export type RouteConfig = {
  path: string;
  component: React.ComponentType;
  title: string;
};
